<template>
  <div>
    <h1 class="title is-4">Clientes</h1>
    <div class="columns">
      <div class="column">
        <label class="label">Cliente</label>
        <div class="field has-addons">
          <div class="control is-expanded">
            <input
              id="cl1"
              class="input"
              v-model="cliente.descripcion"
              type="text"
              placeholder="Seleccionar cliente"
            />
          </div>
          <div class="control">
            <a class="button is-info" @click="launchModal"> Buscar </a>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <table class="table">
          <tbody>
            <tr
              v-for="(item3, index3) in cliente.vendedores.list"
              :key="index3"
            >
              <td style="width: 80%">
                <div class="control">
                  <div class="select is-fullwidth">
                    <select
                      v-model="cliente.vendedores.list[index3]"
                      :disabled="item3 === 'all'"
                      @change="selectSeller(index3)"
                    >
                      <option :value="'all'">Todos</option>
                      <option
                        v-for="(item4, index4) in vendedores"
                        :key="index4"
                        :value="item4._id"
                      >
                        {{ item4.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </td>
              <td style="width: 10%">
                <div class="control">
                  <input
                    class="input"
                    v-model="cliente.vendedores[item3].percentage"
                    type="text"
                    placeholder="Seleccionar cliente"
                  />
                </div>
              </td>
              <td style="width: 10%">
                <div class="buttons has-addons is-right">
                  <button
                    v-show="
                      index3 === cliente.vendedores.list.length - 1 &&
                      cliente._id
                    "
                    class="button"
                    @click="addSeller()"
                  >
                    <span class="icon is-small">
                      <span class="material-icons">add_circle </span>
                    </span>
                  </button>
                  <button
                    v-show="item3 !== 'all'"
                    class="button is-danger"
                    @click="deleteSeller(index3)"
                  >
                    <span class="icon is-small">
                      <span class="material-icons"> delete_forever </span>
                    </span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <button class="button is-primary" @click="save">Guardar</button>
    <button class="button is-light" @click="cancel">Cancelar</button>

    <hr />
    <table class="table">
      <thead>
        <tr>
          <th>Cliente - Vendedor</th>
          <th>Porcentaje</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-for="(item, index) in clientes" :key="index">
        <tr>
          <td>{{ item.descripcion }}</td>
          <td></td>
          <td>
            <div class="buttons has-addons">
              <button class="button is-small" @click="edit(item)">
                <span class="icon is-small">
                  <span class="material-icons"> mode_edit </span>
                </span>
              </button>
              <button class="button is-small is-danger" @click="eliminar(item)">
                <span class="icon is-small">
                  <span class="material-icons"> delete_forever </span>
                </span>
              </button>
            </div>
          </td>
        </tr>
        <tr v-for="(item2, index2) in item.vendedores.list" :key="index2">
          <td>{{ nameSellers[item2] }}</td>
          <td>{{ item.vendedores[item2].percentage }}%</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      cliente: {
        _id: null,
        idnit: null,
        descripcion: null,
        vendedores: {
          list: ["all"],
          all: {
            percentage: 100,
          },
        },
      },
      clientes: [],
      nameSellers: {
        all: "Todos",
      },
      vendedores: [],
    };
  },
  computed: {
    ...mapState(["modalnotification", "nits", "resultDatamodal"]),
    resultnotification() {
      return this.modalnotification.result.aceptar;
    },
  },
  methods: {
    deleteSeller(index) {
      const _this = this;
      const replacement = JSON.parse(
        JSON.stringify(_this.cliente.vendedores.list[index])
      );
      this.cliente.vendedores.list.splice(index, 1);
      this.$delete(this.cliente.vendedores, replacement);
    },
    selectSeller(index) {
      const replacement = this.cliente.vendedores.list[index];
      this.cliente.vendedores.list.splice(index, 1, replacement);
      this.$set(this.cliente.vendedores, replacement, { percentage: 100 });
      this.$delete(this.cliente.vendedores, "0");
    },
    addSeller() {
      this.cliente.vendedores.list.push("0");
      this.$set(this.cliente.vendedores, "0", { percentage: 100 });
    },
    async findSellers() {
      try {
        const result = await apiServices.get(`/getvendedores`);
        const _this = this;
        if (result.data) {
          this.vendedores = result.data;
          this.nameSellers = { all: "Todos" };
          for (let index in result.data) {
            const seller = result.data[index];
            _this.nameSellers[seller._id] = seller.nombre;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    launchModal() {
      const datanits = this.nits.map((e) => {
        const d = {
          codigo: e.codigo,
          nombre: e.nombre,
          id: e._id,
          selected: false,
        };
        return d;
      });
      this.$store.commit("launchModal", {
        title: "Seleccione el Cliente",
        oktext: "Aceptar",
        canceltext: "Cancelar",
        titleTable: [
          { cod: "codigo", name: "Código" },
          { cod: "nombre", name: "Nombre" },
        ],
        table: datanits,
        result: "cl1",
      });
    },
    async save() {
      try {
        if (!this.cliente.idnit) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar un cliente",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (this.cliente._id) {
          await apiServices.post(`/editcliente`, this.cliente);
        } else {
          await apiServices.post(`/createcliente`, this.cliente);
        }
        this.cliente = {
          _id: null,
          idnit: null,
          descripcion: null,
          vendedores: {
            list: ["all"],
            all: {
              percentage: 100,
            },
          },
        };
        this.find();
      } catch (err) {
        console.log(err);
      }
    },
    async find() {
      try {
        const _this = this;
        const result = await apiServices.get(`/getclientes`);
        if (result.data) {
          this.clientes = [];
          for (let index in result.data) {
            const dato = result.data[index];
            const d = {
              _id: dato._id,
              idnit: dato.idnit,
              descripcion: `${dato.idnit.codigo} - ${dato.idnit.nombre}`,
              vendedores: dato.vendedores,
            };
            _this.clientes.push(d);
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async edit(cliente) {
      try {
        this.cliente = JSON.parse(JSON.stringify(cliente));
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (err) {
        console.log(err);
      }
    },
    cancel() {
      this.cliente = {
        _id: null,
        idnit: null,
        descripcion: null,
        vendedores: {
          list: ["all"],
          all: {
            percentage: 100,
          },
        },
      };
    },
    eliminar(cliente) {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "Atención!",
          message: "Realmente desea eliminar la configuración de este cliente?",
          clase: "is-warning",
          data: cliente._id,
        },
      });
    },
    async deleteedad(idcliente) {
      try {
        await apiServices.delete(`/deletecliente/${idcliente}`);
        this.find();
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    resultnotification(nv, ov) {
      if (nv) {
        this.deleteedad(this.modalnotification.result.data);
      }
    },
    resultDatamodal(newv, oldv) {
      if (newv.result === "cl1") {
        this.cliente.descripcion = `${newv.data.codigo} - ${newv.data.nombre}`;
        this.cliente.idnit = newv.data.id;
        document.getElementById("cl1").focus();
      }
    },
  },
  created() {
    this.find();
    this.findSellers();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/comisiones/Clientes.vue